import { faSpinner, faSquareCheck } from "@fortawesome/free-solid-svg-icons";
import { faSquare } from "@fortawesome/free-regular-svg-icons";
import { useCallback, useState } from "react";
import { DateTime } from "luxon";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { StoppageDto } from "../../../DTOs/Stoppage/StoppageDto";
import ConfirmSetAvailableModal from "../ConfirmSetAvailableModal";
import { useGlobalModal } from "../../../components/Contexts/GlobalModalContext";
import { useIsReadOnly } from "../../../utilities/helpers/roleUtilities";

type StatusCellProps = {
  stoppage: StoppageDto;
  machineName: string;
  status: string;
  setAsAvailable: (stoppage: StoppageDto) => Promise<boolean>;
};

const StoppageStatusCell: React.FC<StatusCellProps> = ({ stoppage, machineName, status, setAsAvailable }) => {
  const isReadOnly = useIsReadOnly();
  const { showModal, hideModal } = useGlobalModal();
  const [isWorking, setIsWorking] = useState(false);

  const handleSetAvailable = useCallback(async () => {
    setIsWorking(true);
    await setAsAvailable(new StoppageDto({
      ...stoppage,
      startTime: stoppage.startTime || DateTime.now(),
      endTime: DateTime.now(),
      stoppageTypeId: stoppage.stoppageTypeId ?? 0,
      stoppageSubTypeId: stoppage.stoppageSubTypeId ?? 0
    })) && hideModal();
    setIsWorking(false);
  }, [hideModal, setAsAvailable, stoppage]);

  const showConfirmModal = useCallback(() => {
    if (isReadOnly) return;

    showModal({
      content: <ConfirmSetAvailableModal
        machineName={machineName}
        handleSetAvailable={handleSetAvailable}
      />
    })
  }, [handleSetAvailable, isReadOnly, machineName, showModal]);

  return (
    <span
      className="relative inline-flex w-full h-full items-center justify-center group cursor-pointer"
      onClick={showConfirmModal}
    >
      {isWorking ? (
        <FontAwesomeIcon icon={faSpinner} spin className="text-theme-text transition-opacity" />
      ) : status !== "UP" && (
        <>
          <FontAwesomeIcon
            icon={faSquare}
              size="2x"
              className={`transition-opacity absolute opacity-100 group-hover:opacity-0 ${isReadOnly ? 'text-theme-text-muted' : 'text-theme-text' }`}
          />
          <FontAwesomeIcon
            icon={faSquareCheck}
            size="2x"
              className={`transition-opacity absolute opacity-0 group-hover:opacity-100 ${isReadOnly ? 'text-theme-text-muted' : 'text-theme-success' }`}
          />
        </>
      )}
    </span>
  );
};

export default StoppageStatusCell;